import MenuIcon from '@mui/icons-material/Menu';
import { Typography, styled, Toolbar, IconButton } from '@mui/material';
import MuiAppBar, { AppBarProps } from '@mui/material/AppBar';
import { useUser } from 'hooks/useUser';
import { useMemo } from 'react';

interface IAppBarProps extends AppBarProps {
  open?: boolean;
}

const drawerWidth: number = 240;
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<IAppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const Navbar = (props: any) => {
  const { openSideMenu, toggleDrawer, pageTitle } = props;
  const {
    user: { name, crmv, responsible },
  } = useUser();

  const userName = useMemo(() => {
    if (crmv) {
      return `${name} - CRMV ${crmv}`;
    }

    return name || responsible || 'Parceiro';
  }, [crmv, name, responsible]);

  return (
    <AppBar position="absolute" open={openSideMenu}>
      <Toolbar
        sx={{
          pr: '24px', // keep right padding when drawer closed
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{
            marginRight: '36px',
            ...(openSideMenu && { display: 'none' }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1, color: '#FFFFFF', fontWeight: 500 }}
        >
          {pageTitle ? pageTitle : ''}
        </Typography>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          sx={{ color: '#FFFFFF', fontWeight: 500 }}
        >
          {userName}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

